import { TOGGLE_CREDIT_LIMIT_REACHED_MODAL } from 'email-management-lib/refactor/actions/actionTypes';
export default function hasReachedLimitModalOpen(state = false, action) {
  if (action.type === TOGGLE_CREDIT_LIMIT_REACHED_MODAL) {
    return action.isOpen;
  }
  return state;
}